module.exports = __webpack_public_path__ + "static/logo_isba-48bb5202f165ee4eb55be704bb184d18.png";